import React from 'react';

interface SearchBarAndFiltersSkeletonProps {
  filterCount?: number;
}

export function SearchBarAndFiltersSkeleton({
  filterCount = 4,
}: SearchBarAndFiltersSkeletonProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-4 w-full will-change-opacity">
      {/* Search Bar Skeleton */}
      <div className="relative flex-1">
        <div className="h-12 bg-gray-200 rounded-md animate-pulse"></div>
      </div>

      {/* Filter Buttons Skeleton */}
      <div className="flex gap-2 overflow-x-auto pb-1">
        {[...Array(filterCount)].map((_, index) => (
          <div
            key={index}
            className="h-12 w-28 bg-gray-200 rounded-md animate-pulse shrink-0"
            style={{ animationDelay: `${index * 0.1}s` }}
          ></div>
        ))}
      </div>
    </div>
  );
}
